module.exports = __webpack_public_path__ + "static/img/closed-null.d0f2a5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/closed-null.png
// module id = lHbD
// module chunks = 1